











import { useVideoProperties } from '@ks/player';
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    props: {
        errorInfo: {
            type: Object,
            default: () => {
                return {
                    errorTitle: '无法连接网络，请稍后再试',
                    retryText: '点击重试',
                };
            },
        },
    },
    setup() {
        const {
            currentTime,
        } = useVideoProperties();
        return {
            currentTime,
        };
    },
});
